import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import TransactionItem from "./Component/TransactionItem";
// import { ArrowRightShort, ExclamationCircle } from "react-bootstrap-icons";
import { isMobile } from "react-device-detect";
import ApiUserTransaction from "./../../../core/api/api.userTransaction";
import SplitNumber from "../../components/SplitNumber";
import ContextApp from "./../../../core/contexts/context.app";
import _ from "lodash";
import { Zoom } from "react-awesome-reveal";
import { IconArrowRight, IconErrorCircle } from "../../../assets/icons";
import DottedLoadingData from "../../components/DottedLoadingData";
// import { RotateCircleLoading } from "react-loadingg";
function TransactionList() {
  const [liveData, setLiveData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const ctx = useContext(ContextApp);

  useEffect(() => {
    if (ctx.isAuth) getData();
    else {
    }
  }, [ctx.isAuth]);

  async function getData() {
    try {
      // گرفتن تراکنش های کیف پول
      const response = await ApiUserTransaction.getAllUserTransaction({
        pageNumber: 1,
        pageSize: 50,
      });

      setIsLoading(false);
      if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
        setLiveData(response.data);
      }
      // else setNoData;
    } catch (error) {}
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container fluid={true} className="main-content  px-2  bg-light-3">
      {!isMobile ? (
        <Container>
          <Row className="pt-3 pb-2 fs-085">
            <Col xs={12} className="px-0">
              <Link to="/" className="text-muted">
                {" "}
                صفحه اصلی{" "}
              </Link>{" "}
              /{" "}
              <Link to="/profile" className="text-muted">
                {" "}
                پروفایل{" "}
              </Link>{" "}
              /{" "}
              <Link to="/transaction" className="text-muted font-weight-bold">
                {" "}
                تراکنش های کیف پول{" "}
              </Link>
            </Col>
          </Row>
        </Container>
      ) : (
        <Col xs={12} className="pt-3">
          <Link to="/wallet" className="text-right text-dark large-svg ps-2">
            <IconArrowRight fillColor="#000" />
            <h3 className="my-auto d-inline-block fs-normal">
              {" "}
              تراکنش های کیف پول
            </h3>
          </Link>
        </Col>
      )}
      <Container className="min-height-page">
        <Row>
          {isLoading ? (
            <div className="mt-3">
              <DottedLoadingData withText="false" />
            </div>
          ) : liveData.length > 0 ? (
            <>
              {liveData?.map((itemData, index) => (
                <TransactionItem
                  key={index}
                  ItemCharge={itemData.balanceType}
                  ItemPrice={itemData.amount}
                  Amount={itemData.riallBalance}
                  ItemTime={itemData.completionTime}
                  ItemDate={itemData.completionDate}
                  ItemDescription={itemData.description}
                  Title={
                    !_.isEmpty(itemData.trackingCode) ? "کد پیگیری : " : ""
                  }
                  ItemCode={
                    !_.isEmpty(itemData.trackingCode)
                      ? itemData.trackingCode
                      : ""
                  }
                />
              ))}
            </>
          ) : (
            <Row className=" pt-xl-0 pt-md-0 transaction-box vh-100 xl-svg ">
              <div className="text-center">
                <IconErrorCircle fillColor="#b1b1b1" />

                <div className="text-center my-2 text-muted pb-4">
                  تراکنشی وجود ندارد!
                </div>
              </div>
            </Row>
          )}
        </Row>
      </Container>
    </Container>
  );
}
export default TransactionList;
